// Čista logika za nove obrasce radnika (EmployeeCreate / EmployeeEdit2 / kasnije EmployeeEdit3).
// Bez baze, bez Vuea, bez DOM-a (osim citajIzgled/spremiIzgled koji koriste localStorage u try/catch).

// Vrijednost je "prazna" ako nije upisana. Nula i false NISU prazni (nula je upisana vrijednost).
export const jePrazno = (v) =>
  v === null || v === undefined || (typeof v === 'string' && v.trim() === '')

// Oznake u empDesc*.js imaju na kraju " *" — zvjezdicu crta sam obrazac.
export const cistaOznaka = (s) => String(s === undefined || s === null ? '' : s).replace(/\s*\*\s*:?\s*$/, '')

// ---------- izmjene ----------
export const kloniraj = (o) => JSON.parse(JSON.stringify(o === undefined ? {} : o))

// Normalizacija za usporedbu: prazno/undefined/null/false su "isto"; "40.00" i 40 su isto;
// datum s vremenom ("2024-01-31T00:00:00.000Z") usporedi se samo po danu.
const normaliziraj = (v) => {
  if (v === null || v === undefined || v === false) return ''
  if (v === true) return 'true'
  if (typeof v === 'number') return isFinite(v) ? String(v) : ''
  const s = String(v).trim()
  if (s === '') return ''
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10)
  if (/^-?\d+([.,]\d+)?$/.test(s)) return String(Number(s.replace(',', '.')))
  return s
}
export const jednako = (a, b) => normaliziraj(a) === normaliziraj(b)

// Popis ključeva čija se vrijednost razlikuje od izvornika.
export const izmijenjenaPolja = (izvornik, trenutni, kljucevi) => {
  const iz = izvornik || {}
  const tr = trenutni || {}
  return kljucevi.filter((k) => !jednako(iz[k], tr[k]))
}

// ---------- provjere (vraćaju poruku ili null) ----------
export const oibIspravan = (s) => {
  if (!/^\d{11}$/.test(s)) return false
  let a = 10
  for (let i = 0; i < 10; i++) {
    a = (a + parseInt(s[i], 10)) % 10
    if (a === 0) a = 10
    a = (a * 2) % 11
  }
  let k = 11 - a
  if (k === 10) k = 0
  return k === parseInt(s[10], 10)
}

export const oibUpozorenje = (v) => {
  if (jePrazno(v)) return null
  const s = String(v).trim()
  if (!/^\d{11}$/.test(s)) return 'OIB obično ima 11 znamenki (stranci mogu imati drukčiji broj)'
  if (!oibIspravan(s)) return 'Kontrolna znamenka OIB-a nije ispravna'
  return null
}

export const emailUpozorenje = (v) => {
  if (jePrazno(v)) return null
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()) ? null : 'Email ne izgleda ispravno'
}

export const ibanIspravan = (s) => {
  s = String(s).replace(/\s/g, '').toUpperCase()
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s)) return false
  const r = s.slice(4) + s.slice(0, 4)
  let n = ''
  for (let i = 0; i < r.length; i++) {
    const c = r[i]
    n += /\d/.test(c) ? c : String(c.charCodeAt(0) - 55)
  }
  let m = 0
  for (let j = 0; j < n.length; j++) m = (m * 10 + parseInt(n[j], 10)) % 97
  return m === 1
}

export const ibanUpozorenje = (v) => {
  if (jePrazno(v)) return null
  const s = String(v).replace(/\s/g, '')
  if (!/^[A-Za-z]{2}/.test(s)) return null // stari brojevi računa bez IBAN-a
  return ibanIspravan(s) ? null : 'IBAN nije ispravan (kontrolna znamenka)'
}

// Datumi kao "YYYY-MM-DD" (ili ISO s vremenom) pa leksikografska usporedba vrijedi.
export const krajPrijePocetka = (pocetak, kraj) => {
  if (jePrazno(pocetak) || jePrazno(kraj)) return null
  const p = String(pocetak).slice(0, 10)
  const k = String(kraj).slice(0, 10)
  return k < p ? 'Kraj rada je prije početka rada' : null
}

// Hashtag koji se ne provjerava kao sukob (prazan i legacy "-").
export const hashtagTrebaProvjeru = (h) => {
  if (jePrazno(h)) return false
  return String(h).trim() !== '-'
}

// ---------- validacija ----------
// definicija = {
//   obavezna: { Kljuc: 'Poruka' },                  // blokiraju spremanje
//   upozorenja: { Kljuc: (vrijednost, model) => poruka|null },  // samo žuto
//   greske: { Kljuc: (vrijednost, model) => poruka|null }       // dodatne tvrde greške (npr. hashtag zauzet)
// }
export const validiraj = (model, definicija) => {
  const m = model || {}
  const d = definicija || {}
  const greske = {}
  const upozorenja = {}
  Object.keys(d.obavezna || {}).forEach((k) => {
    if (jePrazno(m[k])) greske[k] = d.obavezna[k]
  })
  Object.keys(d.greske || {}).forEach((k) => {
    if (greske[k]) return
    const p = d.greske[k](m[k], m)
    if (p) greske[k] = p
  })
  Object.keys(d.upozorenja || {}).forEach((k) => {
    if (greske[k]) return
    const p = d.upozorenja[k](m[k], m)
    if (p) upozorenja[k] = p
  })
  return { greske, upozorenja }
}

// Ključ prvog polja s greškom prema zadanom redoslijedu (redoslijed polja na ekranu).
export const prvaGreska = (greske, redoslijed) => {
  const g = greske || {}
  const naRedu = (redoslijed || []).find((k) => g[k])
  return naRedu || Object.keys(g)[0] || null
}

// Koliko je od ključeva popunjeno (false i nula računaju se kao popunjeno samo ako nisu false).
export const brojPopunjenih = (model, kljucevi) => {
  const m = model || {}
  return (kljucevi || []).filter((k) => !jePrazno(m[k]) && m[k] !== false).length
}

// Poruka iz greške: server šalje { error } (string ili objekt), mreža šalje Error.
export const porukaIzGreske = (e) => {
  if (!e) return ''
  if (typeof e === 'string') return e
  if (e.response && e.response.data) {
    const d = e.response.data
    if (typeof d === 'string') return d
    if (typeof d.error === 'string') return d.error
    if (d.error && d.error.message) return d.error.message
    if (d.message) return d.message
  }
  return e.message ? e.message : String(e)
}

// ---------- izbor izgleda (novi / stari) ----------
export const citajIzgled = (kljuc) => {
  try {
    return window.localStorage.getItem(kljuc) === 'stari' ? 'stari' : 'novi'
  } catch (e) {
    return 'novi'
  }
}
export const spremiIzgled = (kljuc, izgled) => {
  try {
    window.localStorage.setItem(kljuc, izgled)
  } catch (e) {
    // ignore
  }
}
